module.exports = __webpack_public_path__ + "static/media/high-resources-xl.9afa9b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/high-resources-xl.jpg
// module id = 412
// module chunks = 13